import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class NumericalService {
  constructor() {}

  public preventNonNumericalInput(e) {
    e = e || window.event;
    var charCode = typeof e.which == "undefined" ? e.keyCode : e.which;
    var charStr = String.fromCharCode(charCode);

    if (!charStr.match(/^[0-9]+$/)) e.preventDefault();
  }
}
